import axios from 'axios';
import { API_ROOT } from '../../urls';
import forEach from 'lodash/forEach';
import store from '../store';

export const fetchPatientRecord = (params) => {
  const url = `${API_ROOT}/${params.collection}/${params.id}/get_whole_rec`;
  return new Promise((resolve) => {
    axios.get(url).then((res) => {
      const patientData = res.data;
      resolve(patientData);
    });
  });
};
export const fetchGetRecordNames = (params) => {
  // A pattern of --all-- returns all records.
  const url = `${API_ROOT}/${params.collection}/${params.pattern}/get_recs`;
  return new Promise((resolve) => {
    axios
      .get(url)
      .then((res) => {
        const data = res.data;
        resolve(data);
      })
      .catch((error) => {
        resolve(error);
      });
  });
};
export const fetchGetRecordName = (params) => {
  const url = `${API_ROOT}/${params.collection}/${params.id}/get_rec`;
  return new Promise((resolve) => {
    axios
      .get(url)
      .then((res) => {
        const data = res.data;
        resolve(data);
      })
      .catch((error) => {
        resolve(error);
      });
  });
};
export const fetchChildFields = (params) => {
  /* return the children (entire fields) of a  parent whose id
     is parent_id.
  */
  const url = `${API_ROOT}/${params.collection}/${params.parent_id}/get_children`;
  return new Promise((resolve) => {
    axios
      .get(url)
      .then((res) => {
        const data = res.data;
        resolve(data);
      })
      .catch((error) => {
        resolve(error);
      });
  });
};
export const fetchSiblings = (params) => {
  /* return the children (entire fields) of children of their parent whose id
     is parent_id and are contained in the medical record root_id
  */
  const url = `${API_ROOT}/${params.collection}/${params.my_id}/get_siblings`;
  return new Promise((resolve) => {
    axios
      .get(url)
      .then((res) => {
        const data = res.data;
        resolve(data);
      })
      .catch((error) => {
        resolve(error);
      });
  });
};
export const fetchParent = (params) => {
  /* return the children (entire fields) of children of their parent whose id
     is parent_id and are contained in the medical record root_id
  */
  const url = `${API_ROOT}/${params.collection}/${params.my_id}/get_parent`;
  return new Promise((resolve) => {
    axios
      .get(url)
      .then((res) => {
        const data = res.data;
        resolve(data);
      })
      .catch((error) => {
        resolve(error);
      });
  });
};
export const fetchParentChildren = (params) => {
  /* return the children (entire fields) of children of their parent whose id
     is parent_id and are contained in the medical record root_id
  */
  const url = `${API_ROOT}/${params.collection}/${params.my_id}/get_parent_children`;
  return new Promise((resolve) => {
    axios
      .get(url)
      .then((res) => {
        const data = res.data;
        resolve(data);
      })
      .catch((error) => {
        resolve(error);
      });
  });
};

export const fetchWholeRecord = (params) => {
  /* return the children (entire fields) of children of their parent whose id
     is parent_id and are contained in the medical record root_id
  */
  const url = `${API_ROOT}/${params.collection}/${params.my_id}/get_whole_rec`;
  return new Promise((resolve) => {
    axios
      .get(url)
      .then((res) => {
        const data = res.data;
        resolve(data);
      })
      .catch((error) => {
        resolve(error);
      });
  });
};

export const updateRec = (obj) => {
  /* Update a medical record
     params are the medical record _id and the object to add or update.
     Obj can also be an array of children

     to add: object must contain it's parent's id but not its own _id.
     to update: object must contain it's parent and its own _id.
     same rules apply to an array of objects.

     Objects cannot be composites. In other words a parent and its children
     cannot be updated with one call. They must be separated.

     Returns the added or modified object.
  */
  const url = `${API_ROOT}/update_rec`;
  return new Promise((resolve) => {
    axios
      .post(url, obj)
      .then((res) => {
        const data = res.data;
        resolve(data);
      })
      .catch((error) => {
        resolve(error);
      });
  });
};

export const updateWholeRec = (obj) => {
  /* Update a medical record
     The record specified by its root id (in obj)  is replaced by obj.

     Returns the replaced tree. 
  */
  const url = `${API_ROOT}/update_whole_rec`;
  return new Promise((resolve) => {
    axios
      .post(url, obj)
      .then((res) => {
        const data = res.data;
        resolve(data);
      })
      .catch((error) => {
        resolve(error);
      });
  });
};

export const createRec = (obj) => {
  /* Create a medical record
     Obj is a tree. The id's are filled in by the server

     Returns the created record or error
  */
  const url = `${API_ROOT}/create_rec`;
  return new Promise((resolve) => {
    axios
      .post(url, obj)
      .then((res) => {
        const data = res.data;
        resolve(data);
      })
      .catch((error) => {
        resolve(error);
      });
  });
};

/*
***********
 The code below is legacy and should not be used.
***********
*/

export const fetchFindIndex = (collection, filter) => {
  const url = `${API_ROOT}/${collection}/find-one/`;
  return new Promise((resolve) => {
    axios.post(url, filter).then((res) => {
      const data = res.data;
      resolve(data);
    });
  });
};

export const deleteFromCollection = (collection, id) => {
  const url = `${API_ROOT}/${collection}/${id}/`;
  return new Promise((resolve) => {
    axios.delete(url).then((res) => {
      const data = res.data;
      resolve(data);
    });
  });
};
export const fetchFilteredCollection = (collection, filter) => {
  const url = `${API_ROOT}/${collection}/find/`;
  return new Promise((resolve) => {
    axios
      .post(url, filter)
      .then((res) => {
        const data = res.data;
        resolve(data);
      })
      .catch((error) => {
        resolve({ error: error });
      });
  });
};

export class API {
  findOne(collection, filter) {
    const url = `${API_ROOT}/${collection}/find-one/`;
    return axios.post(url, filter);
  }
  find(collection, filter) {
    const url = `${API_ROOT}/${collection}/find/`;
    return axios.post(url, filter);
  }
  post(collection, data) {
    if (!Array.isArray(data)) {
      data = [data];
    }
    const url = `${API_ROOT}/${collection}/`;
    return axios.post(url, data);
  }
  replaceOne(collection, id, data) {
    const url = `${API_ROOT}/${collection}/${id}/`;
    return axios.post(url, data);
  }
  deleteOne(collection, id) {
    const url = `${API_ROOT}/${collection}/${id}/`;
    return axios.delete(url);
  }
  async getCategoryDefinitionsById(thestore) {
    // Returns all categories and templates in an object keyed by id
    let allCategoryDefinitions = {};
    await this.find('templates', {})
      .then((response) => {
        forEach(response.data, function(categoryDefinition) {
          allCategoryDefinitions[categoryDefinition._id] = categoryDefinition;
        });
        this.find('terms', {}).then((response) => {
          forEach(response.data, function(template) {
            allCategoryDefinitions[template._id] = template;
          });
          store.commit('setAllCategoryDefinitionsById', {
            categoryDefinitions: allCategoryDefinitions,
          });
        });
      })
      .catch((error) => {
        console.error(error);
      });
    return allCategoryDefinitions;
  }
  getTypes() {
    return new Promise((resolve, reject) => {
      resolve({
        data: [
          {
            key: 'section',
            display_name: 'Section',
            description: 'Section',
            needs_data: false,
            class: 'complex',
          },
          {
            key: 'numerical-range',
            display_name: 'Numerical range',
            description:
              'Range of numerical values separated by a colon (e.g. -1:150)',
            needs_data: true,
            class: 'simple',
          },
          {
            key: 'date',
            display_name: 'Date',
            description: 'Date',
            needs_data: false,
            class: 'simple',
          },
          {
            key: 'value',
            display_name: 'Value',
            description: 'Single value.  May be either numerical or a string.',
            needs_data: false,
            class: 'simple',
          },
          {
            key: 'value-list',
            display_name: 'Value list',
            description: 'One or more values separated by commas.',
            needs_data: true,
            class: 'simple',
          },
          {
            key: 'multiple-value-list',
            display_name: 'Multiple value list',
            description: 'One or more values separated by commas.',
            needs_data: true,
            class: 'simple',
          },
          {
            key: 'category',
            display_name: 'Category',
            description: 'An existing Category',
            needs_data: true,
            class: 'simple',
          },
        ],
      });
    });
  }

  async updateIndex(index, index_id) {
    if (!index_id) {
      return this.post('indexes', index);
    } else {
      if (index._id) {
        delete index['_id'];
      }
      return this.replaceOne('indexes', index_id, index);
    }
  }

  /*
   * These api calls replace the legacy calls above that are deprecated.
   * More calls are added as needed.
   * each call returns a promise.
   */
  get_record_names(pattern) {
    /* return the [{name: nn, _id: yy}, ..] of medical records matching the
       case insensitivbe pattern.
    */
    const url = `${API_ROOT}/${pattern}/get_recs`;
    return axios.get(url);
  }
  get_record_name(id) {
    /* return the {name: nn, _id: yy} of medical record given its id.
     */
    const url = `${API_ROOT}/${id}/get_rec`;
    return axios.get(url);
  }
  get_child_fields(parent_id) {
    /* return the children (entire fields) of children of their parent whose id
       is parent_id and are contained in the medical record root_id
    */
    const url = `${API_ROOT}/${parent_id}/get_children`;
    return axios.get(url);
  }
  get_siblings(my_id) {
    /* return the children (entire fields) of children of their parent whose id
       is parent_id and are contained in the medical record root_id
    */
    const url = `${API_ROOT}/${my_id}/get_siblings`;
    return axios.get(url);
  }
  get_parent(my_id) {
    /* return the children (entire fields) of children of their parent whose id
       is parent_id and are contained in the medical record root_id
    */
    const url = `${API_ROOT}/${my_id}/get_parent`;
    return axios.get(url);
  }
  get_parent_children(my_id) {
    /* return the children (entire fields) of children of their parent whose id
       is parent_id and are contained in the medical record root_id
    */
    const url = `${API_ROOT}/${my_id}/get_parent_children`;
    return axios.get(url);
  }
  get_whole_rec(my_id) {
    /* Get whole record from root with children embedded
     */
    const url = `${API_ROOT}/${my_id}/get_whole_rec`;
    return axios.get(url);
  }
}
